import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {GAME_STATUSES} from "../../../core/app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class H2hWidgetAnalyticsDisplayEvent extends BaseAnalyticsEvent {
  gameId: Number;
  status: GAME_STATUSES;
  clickType: Number;
  sportTypeId: Number;

  constructor(params) {
    super('', 'display', 'h2h');

    this.gameId = params.gameId;
    this.status = params.status;
    this.clickType = params.clickType;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.sportTypeId = this.sportTypeId;


    return properties;
  }
}